// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAwX7wf8j5TanPOPh4-SMPfcuRDWkTw-cE",
  authDomain: "elite-studio-429e1.firebaseapp.com",
  projectId: "elite-studio-429e1",
  storageBucket: "elite-studio-429e1.appspot.com",
  messagingSenderId: "355224716904",
  appId: "1:355224716904:web:29d95b3ead0b9a2f5adddd",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;
